package com.narbase.letsgo.web.utils.views

import com.narbase.kunafa.core.components.View
import com.narbase.kunafa.core.components.imageView
import com.narbase.kunafa.core.css.*
import com.narbase.kunafa.core.dimensions.dimen
import com.narbase.kunafa.core.dimensions.px
import com.narbase.letsgo.web.common.AppColors

/*
 * NARBASE TECHNOLOGIES CONFIDENTIAL
 * ______________________________
 * [2017] -[2019] Narbase Technologies
 * All Rights Reserved.
 * Created by islam
 * On: 2024/01/23.
 */

fun View.deleteIcon(onDelete: () -> Unit) {
    imageView {
        style {
            width = 24.px
            height = 24.px
            borderRadius = 4.px
            border = "1px solid transparent"
            padding = "1px 2px 2px".dimen()
            hover {
                backgroundColor = AppColors.white
                border = "1px solid ${AppColors.separatorNormal}"
            }
        }
        onClick = {
            it.stopPropagation()
            onDelete()
        }
        element.src = "/public/img/delete.png"
    }
}

fun View.printIcon(onClick: () -> Unit) = imageView {
    style {
        width = 24.px
        height = 24.px
        borderRadius = 4.px
        border = "1px solid transparent"
        padding = 3.px
        opacity = 0.6
        hover {
            backgroundColor = AppColors.white
            border = "1px solid ${AppColors.separatorNormal}"
        }
    }
    this.onClick = {
        it.stopPropagation()
        onClick()
    }
    element.src = "/public/img/print_icon.svg"
}

